<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">{{itemList.mainComplainNumber}}</div>
        </div>
        <!-- <div class="coordinatedResults border_bottom">
            <div class="title">协商结果</div>
            <div class="option">
                <van-RadioGroup
                v-model="resultType"
                checked-color='#07c160'
                style="display:flex;margin-top:15px;justify-content:space-around"
                >
                <van-Radio name='1'>协商成功</van-Radio>
                <van-Radio name='2'>协商失败</van-Radio>
                </van-RadioGroup>
            </div>
        </div>
        <div class="compensationAmount border_bottom">
          <div class="left">赔偿金额</div>
          <input type="number"  class="right money" v-model.trim="money" placeholder="请输入赔偿金额">&nbsp;&nbsp;元
        </div> -->
      </div>
      <div class="remark">
        <div class="titleName">反馈内容</div>
        <div class="notAccepted">
          <van-field placeholder="请输入反馈内容..." type="textarea" maxlength="2000"  v-model="message"/>
        </div>
      </div>
      <!-- <upload :imgUrl="imgUrl"></upload> -->
      <uploadCopy :imgUrl="imgUrl"></uploadCopy>
      <div class="btn">
        <div class="submit">
          <van-button type="primary" @click="handleSubmit">提交</van-button>
        </div>
        <div class="save" @click="handleSaveDetail">
          保存草稿
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis'
    import util from '@/utils/common'
    import uploadCopy from '@/components/uploadCopy'
    export default {
        components: {
            uploadCopy
        },
        data () {
            return {
                flag: false,
                money: '',
                message: '',
                resultType: '1',
                itemList: util.getJsonLocal('item'),
                imgUrl: [] // 上传的图片
            }
        },
        created () {
            this.getSaveDetail();
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val;
            })
        },
        methods: {
            afterRead () {

            },
            // 提交
            handleSubmit () {
                if (this.message.trim().length === 0||this.message.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请输入反馈内容');
                // }else if(this.money.length === 0){
                //     this.$Toast('赔偿金额不能为空');
                }
                else {
                    var resultReson=this.message.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    if(resultReson.replace(/\s*/g,"").length<=10){
                        this.$Toast('请输入10个字以上的反馈内容');
                        return;
                    }    
                    const data = {
                        // complainNumber: this.itemList.complainNumber,
                        mainComplainNumber: this.itemList.mainComplainNumber,
                        subId: this.itemList.subId,
                        departmentEnterpriseId: this.itemList.id,
                        // money: this.money,
                        feedbackContent: this.message.replace(/\s*/g,""),
                        // resultType: this.resultType,
                        images: this.imgUrl
                    }
                    console.log(data);
                    if (this.flag === false) {
                      this.flag = true;
                      api.worker.departmentFeedBack(data).then(res => {
                          if (res.ret === 0) {
                              this.$Toast('操作成功');
                              this.$router.back();
                          }
                      })
                    }
                }
            },
            // 保存
            handleSaveDetail () {
                if (this.message.trim().length === 0||this.message.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请输入反馈内容');
                } else {
                    var resultReson=this.message.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    if(resultReson.replace(/\s*/g,"").length<=10){
                        this.$Toast('请输入10个字以上的反馈内容');
                        return;
                    }
                    const data = {
                    mainComplainNumber: this.itemList.mainComplainNumber,
                    // complainNumber: this.itemList.complainNumber,
                    subId: this.itemList.subId,
                    // money: this.money,
                    feedbackContent: this.message.replace(/\s*/g,""),
                    // resultType: this.resultType,
                    images: this.imgUrl
                   }
                    api.worker.saveFeedBack(data).then(res => {
                        console.log(res);
                        if (res.ret === 0) {
                            this.$Toast('操作成功');
                            this.$router.go(-1);
                        }
                    })
                }
            },
            // 获取保存详情
            getSaveDetail () {
                // this.money=34;
                const data = {
                    mainComplainNumber: this.itemList.mainComplainNumber,
                    complainNumber: this.itemList.complainNumber,
                    subId: this.itemList.subId,
                }
                api.worker.getFreeBack(data).then(res => {
                    if (res.data) {
                        this.message = res.data.saveDetails.feedbackContent ? res.data.saveDetails.feedbackContent : '';
                        // this.money = Number(res.data.saveDetails.money)||'';
                        // this.resultType = res.data.saveDetails.resultType ? res.data.saveDetails.resultType.toString() : '1';
                        this.imgUrl = res.data.saveDetails.images;
                    }
                })
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,.compensationAmount {
        display: flex;
        height: 50px;
        align-items: center;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
        }
      }
      .coordinatedResults {
          width: 100%;
          padding: 14px 0;
          font-size: 14px;
          .title {
              color: #333;
          }
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .notAccepted {
        margin-top: 14px;
        .van-cell {
          font-size: 12px;
          background: #efeded;
          border-radius: 7px;
        }
      }
      .addCommandCenter {
          width: 70%;
          margin-left: 15%;
          font-size: 14px;
          height: 45px;
          line-height: 45px;
          color: #bbb;
          border: #ccc dashed 1px;
          text-align: center;
          margin-top: 15px;
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .btn {
      margin-top: 14px;
      .van-button {
        width: 100%;
        border-radius: 7px;
      }
      .save {
          width: 100%;
          margin-top: 10px;
          font-size: 14px;
          height: 44px;
          line-height: 44px;
          background-color: #f0f0f0;
          color: #9c9090;
          text-align: center;
          border-radius: 5px;
          border: solid 1px #dcdcdc
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
